export default __webpack_public_path__ + "static/media/news.4092f38b.png";